import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Helper function to ensure session is fresh
export async function ensureValidSession() {
  const { data: { session }, error } = await supabase.auth.getSession()

  if (error || !session) {
    console.log('No valid session, user needs to log in')
    return null
  }

  // Check if token is about to expire (within 5 minutes)
  const expiresAt = session.expires_at || 0
  const now = Math.floor(Date.now() / 1000)
  const timeUntilExpiry = expiresAt - now

  if (timeUntilExpiry < 300) { // Less than 5 minutes
    console.log('Session about to expire, refreshing...')
    const { data: { session: newSession }, error: refreshError } = await supabase.auth.refreshSession()

    if (refreshError) {
      console.error('Failed to refresh session:', refreshError)
      return null
    }

    return newSession
  }

  return session
}